export const environment = {
  production: false,
  sentry: 'https://08679cfa92f4c62a4df3f6794d5bde51@o446789.ingest.us.sentry.io/4509591841931264',
  name: 'Testing',
  apiUrl: 'https://testing.warehouse.crownbasenxt.be/api',
  lastAppCookieDomain: 'crownbasenxt.be',
  lastAppCookieName: 'rc_last_app_testing',
  auth0: {
    domain: 'staging-royalcrown.eu.auth0.com',
    clientId: 'RFTI8h2J50vDSLtSIxwYhpWXFThFxgGq',
    authorizationParams: {
      redirect_uri: window.location.origin,
      audience: 'https://testing.api.royalcrown.be/',
      logoutUrl: window.location.origin,
    },
    useRefreshTokens: true,
    httpInterceptor: {
      allowedList: [
        {
          // Match any request that starts 'https://{yourDomain}/api/v2/' (note the asterisk)
          uri: `https://testing.warehouse.crownbasenxt.be/api/*`,
          tokenOptions: {
            authorizationParams: {
              // The attached token should target this audience
              audience: 'https://testing.api.royalcrown.be/',
              scope: 'openid profile email offline_access',
            },
          },
        },
      ],
    },
  },
};
